// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1936":"576cb179","2282":"d0fe226a","4079":"a61b4bd4","4826":"ef523a52","5107":"aa65b86a","5557":"a61b4bd4","6771":"11454901","6808":"1a255291","7234":"95326df7","9509":"ca839dc9"}[chunkId] + ".chunk.css";
};